import React from "react";

export default function Projects() {
  return (
    <section id="projects" className="z-section-compact" data-testid="projects">
      <div className="z-page">
        <div className="mx-auto max-w-[760px] text-center">
          <h2 className="font-display text-[28px] md:text-[38px] leading-[1.12]">Context should continue, not restart.</h2>
          <p className="mt-4 text-[16px] md:text-[17px] leading-[1.65] text-[hsl(var(--z-text-muted))]">Approved work can remain available for continuation and review. Drafts, decisions and finished pieces stay organised so the next step begins with context—not from zero.</p>
        </div>
      </div>
    </section>
  );
}
